import styled from "styled-components";

export const ServicePageInner = styled.div`
  display: flex;
  gap: 48px;
  align-items: flex-start;
`;
